import { OptionTitle } from "./OptionTitle"

export const MetabolicDoAnyApplyOptions: Array<OptionTitle> = [
  { title: "Overweight", id: "OVERWEIGHT" },
  { title: "Obesity", id: "OBESITY" },
  { title: "Diabetes, pre-diabetes, or insulin resistance", id: "DIABETES" },
  { title: "Metabolic syndrome", id: "METABOLIC_SYNDROME" },
  { title: "High cholesterol or dyslipidemia", id: "HIGH_CHOLESTEROL" },
  { title: "Polycystic ovary syndrome (PCOS)", id: "PCOS" },
  { title: "Fatty liver disease", id: "FATTY_LIVER_DISEASE" },
  { title: "Lipodystrophy", id: "LIPODYSTROPHY" }
]

export const DoAnyApplyOptions: Array<OptionTitle> = [
  ...MetabolicDoAnyApplyOptions,
  { title: "Over the age of 40", id: "OVER_40" },
  { title: "Two or more unintended pregnancy losses", id: "TWO_LOSSES" },
  { title: "Urgent medical need for fertility preservation", id: "URGENT_MEDICAL_NEED" },
  { title: "Never menstruated", id: "NEVER_MENSTRUATED" },
  { title: "Immediate family member with history of blood clotting disorders", id: "FAMILY_BLOOD_CLOTTING" },
  { title: "None of the above", id: "NONE" }
]
